<template>
  <div>
    <slot name="title"
      ><vAlertHeader title="Pay with PayFast" color="red"></vAlertHeader
    ></slot>

    <v-img
      src="images/payments/instant-eft.png"
      width="100%"
      height="300"
      class="block justify-center mb-6"
    ></v-img>
    <form ref="PayFastPayNowForm">
      <button type="submit" class="block justify-center">
        Pay {{ formatMoney(Number(plan.price)) }}
      </button>
      <!-- <input type="image" src="https://my.payfast.io/images/buttons/PayNow/Dark-Large-PayNow.png" alt="Pay Now" title="Pay Now with Payfast"> -->
    </form>

    <div ref="formSpace"></div>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";
import vAlertHeader from "@/components/Legos/vAlertHeader.vue";

export default {
  updated() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
  },

  components: { vAlertHeader },
  props: {
    selectedPlan: {
      default: () => ({ price: 0 }),
    },
    returnUrl: {
      default: "https://baronitsolutions.co.za/payment-complete",
    },
    cancelUrl: {
      default: "https://baronitsolutions.co.za/cancel-onboarding",
    },
    mPaymentID: {
      default: "",
    },
    customStr: {
      default: null,
    },
    itemName: {
      default: null,
    },
    itemDescription: {
      default: null,
    },
    company: {
      default: null,
    },
  },
  watch: {
    selectedPlan(newVal) {
      this.plan = newVal;
      if (this.plan.price && typeof this.plan.price !== "number") {
        this.plan.price = this.stripNonDigitsAndCommasFromMoney(
          this.plan.price
        );
      }
    },
  },
  computed: {
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
  },
  data: () => ({
    plan: { price: 0 },
    merchantNumber: 12164464,
  }),
  mounted() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
    console.log(this.selectedPlan);
    this.plan = this.selectedPlan;
    if (this.plan.price && typeof this.plan.price !== "number") {
      this.plan.price = this.stripNonDigitsAndCommasFromMoney(this.plan.price);
    }

    const form = this.$refs.PayFastPayNowForm;
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      this.payNowButtonClicked();
    });
  },
  methods: {
    formatMoney(price) {
      return helpersJs.formatMoney(price);
    },
    stripNonDigitsAndCommasFromMoney(price) {
      return helpersJs.stripNonDigitsAndCommasFromMoney(price);
    },
    payNowButtonClicked() {
      this.$store.commit("setLoader", true);
      const payNowform = this.$refs.PayFastPayNowForm;
      const formD = new FormData(payNowform);
      const formData = {};
      for (var [key, value] of formD.entries()) {
        formData[key] = value;
      }

      //Security Additions
      formData["email_confirmation"] = 1;
      formData["confirmation_address"] = "adubyte2@yahoo.com";
      formData["receiver"] = this.merchantNumber;
      formData["cmd"] = "_paynow";
      formData["amount"] =
        this.plan && this.plan.price ? Number(this.plan.price) : 0;
      const amt = this.plan && this.plan.price ? Number(this.plan.price) : 0;

      formData["notify_url"] = this.getApiUrl + "/handle-payfast-notification";
      formData["return_url"] = this.returnUrl;
      formData["cancel_url"] = this.cancelUrl;
      formData["m_payment_id"] = this.mPaymentID;
      formData["custom_str1"] = this.customStr;

      formData["item_name"] = this.itemName;
      formData["item_description"] = this.itemDescription;

      const formSpace = this.$refs.formSpace;
      const form = document.createElement("form");
      form.setAttribute("method", "post");
      form.setAttribute("action", "https://payment.payfast.io/eng/process");

      const keys = Object.keys(formData);
      if (keys.length > 0) {
        for (let i = 0; i < keys.length; i++) {
          const input = document.createElement("input");
          input.setAttribute("name", keys[i]);
          input.setAttribute("value", formData[keys[i]]);
          input.setAttribute("hidden", "true");
          form.appendChild(input);
        }
      }
      const submit = document.createElement("input");
      submit.type = "submit";
      submit.value = "Submit";
      this.$store.commit("setLoader", false);
      formSpace.appendChild(form);
      form.submit();

      // this.$emit("paybutton-clicked", formData);
    },
  },
};
</script>

<style scoped>
.block {
  font-weight: bold;
  color: white;
  border-radius: 12px;
  display: block;
  width: 75%;
  border: none;
  background-color: rgb(13 127 63);
  padding: 14px 28px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
}
</style>
